import 'slick-carousel';

const $slider = $('.js-slider .js-slider-slides')
const $sliderImages = $('.js-slider .js-slider-slides-images')
const speedSlide = 600

$slider.on('init', function(slick){
  $(slick.target).find('.slick-dots').append('<li class="slick-dots-circle"></li>')
});

$slider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  dots: true,
  arrows: false,
  autoplay: false,
  speed: speedSlide,
  asNavFor: $sliderImages
});

$sliderImages.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  speed: speedSlide,
  asNavFor: $slider
});

$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
  const $sliderDot = $(slick.$dots[0]).find('li:first-child button')
  const sliderCurrentDotIdx = $(slick.$dots[0]).find('.slick-active').index()
  const sliderDotWidth = $sliderDot.outerWidth(true)
  const newLeftPos = nextSlide * sliderDotWidth

  $(slick.$dots[0]).find('.slick-dots-circle').css('left', newLeftPos)

  $(slick.$slider).find('.slick-slide').eq(nextSlide).addClass('slick-change').addClass('slick-changed')
  $(slick.$slider).find('.slick-slide').removeClass('slick-changed');

  $(slick.$slider).find('.slick-current').addClass('slick-last')

  setTimeout(function() {
    $(slick.$slider).find('.slick-slide').removeClass('slick-change').removeClass('slick-last')
  }, speedSlide);

  /*if (currentSlide === 0 && nextSlide === (slick.slideCount - 1)) {
    $slider.addClass('slick-slider--prev');

    setTimeout(function() {
      $slider.removeClass('slick-slider--prev');
    }, speedAnimate);
  }*/
});
